import { PhoneNumberDto } from '../generated';

export const parsePhoneNumber = (data: PhoneNumberDto): string => {
  return data.number;
};
